/* #206: collection-based centrepiece minimum. Reuses HFD's pure business-day
 * calculation without HFD labels, page copy or accelerated-checkout changes. */
(function (root) {
  'use strict';
  var hfd = root.fbHfdLeadTime;
  if (!hfd) return;
  var config = root.fbCentrepieceConfig || {};
  var cartIds = config.cartProductIds || [];
  var cart = null;
  var returnToCart = !!(root.location && (root.location.search || '').indexOf('centrepiece_redate=1') !== -1);
  // Location filtering can replace the URL or redirect before a date is saved.
  try {
    var stamp = Number(root.sessionStorage.getItem('fbCentrepieceRedate'));
    if (returnToCart) root.sessionStorage.setItem('fbCentrepieceRedate', String(Date.now()));
    else if (config.pageIsCollection && stamp && Date.now() - stamp < 600000) returnToCart = true;
    else root.sessionStorage.removeItem('fbCentrepieceRedate');
  } catch (e) { /* the address flag still works without storage */ }
  function days() {
    var n = Number(config.businessDays);
    return Number.isFinite(n) ? Math.max(0, Math.min(5, n)) : 2;
  }
  function isProduct(id) {
    if (id == null) return false;
    if ((config.productIds || []).some(function (known) { return known != null && String(known) === String(id); })) return true;
    // AJAX cards/quick view carry membership too, including large collections.
    return !!(root.document && root.document.querySelector('[data-product-id="' + String(id).replace(/[^0-9]/g, '') + '"][data-centrepiece-lead="true"]'));
  }
  function cartHasProduct() { return cartIds.some(isProduct); }
  function applies(id) {
    return days() > 0 && (cartHasProduct() || (id != null ? isProduct(id) : isProduct(config.pageProductId) || config.pageIsCollection === true));
  }
  function earliestForLocation(location, now) {
    if (!days()) return null;
    return hfd.earliestForSettings(hfd.settingsFor(location), now, days());
  }
  function earliestForPostcode(postcode, now) { return earliestForLocation(hfd.locationForPostcode(postcode), now); }
  function read(name) {
    if (root.fbDeliveryDate && root.fbDeliveryDate.read) return root.fbDeliveryDate.read(name);
    var pair = (root.document ? root.document.cookie : '').split(';').find(function (part) { return part.trim().indexOf(name + '=') === 0; });
    if (!pair) return '';
    try { return decodeURIComponent(pair.trim().slice(name.length + 1)); } catch (e) { return ''; }
  }
  function blockedDates(id, location) {
    var data = (config.restrictions || {})[id] || {};
    var dates = (data[location] || []).slice();
    var registered = (root.productsWithDateRestrictions || {})[id];
    if (registered && registered.dateRestrictions) dates = dates.concat(registered.dateRestrictions[location + '_unavailable_dates'] || []);
    if (root.document && root.document.querySelectorAll && id != null) {
      var nodes = root.document.querySelectorAll('[data-product-id="' + String(id).replace(/[^0-9]/g, '') + '"]');
      var suffixes = [String(location).toLowerCase()];
      if (location === 'RestofAustralia') suffixes.push('rest-australia');
      Array.prototype.forEach.call(nodes, function (node) {
        suffixes.forEach(function (suffix) {
          try { dates = dates.concat(JSON.parse(node.getAttribute('data-unavailable-' + suffix) || '[]')); } catch (e) { /* absent data */ }
        });
      });
    }
    return dates;
  }
  function invalidDate(iso, postcode, id, now) {
    var chosen = hfd.toYmd(iso);
    if (!chosen) return false; // missing dates use the ordinary required-date gate
    var location = hfd.locationForPostcode(postcode);
    if (applies(id) && chosen < earliestForLocation(location, now)) return true;
    // Day blocks stay active when the minimum is switched off.
    var ids = [id == null ? config.pageProductId : id].concat(cartIds.filter(isProduct));
    return ids.some(function (productId) { return isProduct(productId) && blockedDates(productId, location).indexOf(chosen) !== -1; });
  }
  function clearDate() {
    ['DeliveryDate', 'ISODate'].forEach(function (name) {
      root.document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      if (root.fbDeliveryDate && root.fbDeliveryDate.settle) root.fbDeliveryDate.settle(name);
    });
  }
  function refuse(id, now) {
    if (!invalidDate(read('ISODate'), read('deliveryPostcode'), id, now)) return false;
    clearDate();
    if (typeof root.popupShowUnavailableToast === 'function') root.popupShowUnavailableToast(null, 'Please choose an available delivery date.');
    if (typeof root.openPopupAtStep === 'function') root.openPopupAtStep('date');
    return true;
  }
  function badLines(state, now) {
    var has = (state.items || []).some(function (line) { return isProduct(line.product_id); });
    if (!has) return [];
    return (state.items || []).filter(function (line) {
      var props = line.properties || {};
      var postcode = read('deliveryPostcode') || props.Postcode;
      var iso = hfd.toYmd(props._ISODate);
      return isProduct(line.product_id) && (!iso || (days() > 0 && iso < earliestForPostcode(postcode, now))
        || blockedDates(line.product_id, hfd.locationForPostcode(postcode)).indexOf(iso) !== -1);
    });
  }
  function guardCart(state, now, failed) {
    if (!root.document || !root.location || !/^\/cart\/?$/.test(root.location.pathname)) return;
    var bad = failed || badLines(state, now).length > 0;
    var button = root.document.getElementById('checkout');
    if (button) {
      if (bad) { button.setAttribute('data-centrepiece-blocked', ''); button.disabled = true; }
      else if (button.hasAttribute('data-centrepiece-blocked')) {
        button.removeAttribute('data-centrepiece-blocked');
        button.disabled = button.hasAttribute('data-hfd-blocked') || button.hasAttribute('data-ratio-blocked') || button.hasAttribute('data-date-blocked') || !state.items.length;
      }
    }
    Array.prototype.forEach.call(root.document.querySelectorAll('.cart__dynamic-checkout-buttons'), function (node) {
      if (bad) { node.setAttribute('data-centrepiece-blocked', ''); node.style.display = 'none'; }
      else if (node.hasAttribute('data-centrepiece-blocked')) {
        node.removeAttribute('data-centrepiece-blocked');
        if (!button || (!button.hasAttribute('data-hfd-blocked') && !button.hasAttribute('data-date-blocked'))) node.style.display = '';
      }
    });
    var notice = root.document.getElementById('fbCentrepieceCartNotice');
    if (!bad) { if (notice) notice.remove(); return; }
    if (!notice) {
      var ctas = root.document.querySelector('.cart__ctas');
      if (!ctas || !ctas.parentNode) return;
      notice = root.document.createElement('div');
      notice.id = 'fbCentrepieceCartNotice'; notice.className = 'cart__ratio-notice'; notice.setAttribute('role', 'alert');
      var text = root.document.createElement('p'); text.textContent = 'Please choose an available delivery date for your centrepieces.';
      var link = root.document.createElement('a'); link.className = 'button button--secondary'; link.textContent = 'Change delivery date';
      link.href = (config.collectionUrl || '/collections/events') + '?centrepiece_redate=1';
      notice.appendChild(text); notice.appendChild(link); ctas.parentNode.insertBefore(notice, ctas);
    }
  }
  // Refresh only carts that can involve these products. Native requests avoid
  // observing our own reads/updates. One in-flight job plus one queued refresh.
  var nativeFetch = root.fetch;
  var inFlight = null;
  async function refresh(save) {
    if (!nativeFetch) return false;
    if (inFlight) return inFlight.then(function () { return refresh(save); });
    inFlight = (async function () {
      try {
        var response = await nativeFetch.call(root, '/cart.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Cart unavailable');
        cart = await response.json();
        cartIds = (cart.items || []).map(function (line) { return line.product_id; });
        config.cartProductIds = cartIds;
        // Only an explicit centrepiece redate changes existing centrepiece lines.
        // Ordinary date saves leave existing lines alone, as on live.
        // Use the latest returned keys after every
        // property change, since Shopify may merge lines with identical properties.
        if (save && returnToCart && cartHasProduct() && read('ISODate') && read('DeliveryDate') && !invalidDate(read('ISODate'), read('deliveryPostcode'), null)) {
          var limit = cart.items.length;
          while (limit-- > 0) {
            var line = cart.items.find(function (item) { return isProduct(item.product_id) && item.properties && item.properties._ISODate && hfd.toYmd(item.properties._ISODate) !== hfd.toYmd(read('ISODate')); });
            if (!line) break;
            var props = Object.assign({}, line.properties, { _ISODate: read('ISODate'), 'Delivery Date': read('DeliveryDate') });
            var update = await nativeFetch.call(root, '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: props }) });
            if (!update.ok) throw new Error('Date update failed');
            cart = await update.json();
          }
          root.document.dispatchEvent(new root.CustomEvent('cart:updated', { detail: { parsedState: cart } }));
        }
        guardCart(cart);
        return !badLines(cart).length;
      } catch (e) { guardCart(cart || { items: [] }, null, true); return false; }
      finally { inFlight = null; }
    })();
    return inFlight;
  }
  var api = { days: days, isProduct: isProduct, applies: applies, earliestForLocation: earliestForLocation,
    earliestForPostcode: earliestForPostcode, invalidDate: invalidDate, blockedDates: blockedDates,
    refuse: refuse, badLines: badLines, guardCart: guardCart, refresh: refresh };
  root.fbCentrepieceLeadTime = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!root.document || !root.addEventListener) return;
  root.document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    if (event.target.closest('.custom_product__add__cart__button') && refuse(config.pageProductId)) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
    if (event.target.closest('#checkout, [name="checkout"], .cart__dynamic-checkout-buttons') && cartHasProduct()
        && (inFlight || !cart || badLines(cart).length)) {
      event.preventDefault(); event.stopImmediatePropagation(); refresh(false);
    }
  }, true);
  root.addEventListener('deliveryInfoUpdated', function () {
    if (cartHasProduct()) refresh(true).then(function (ok) {
      if (ok && returnToCart) {
        try { root.sessionStorage.removeItem('fbCentrepieceRedate'); } catch (e) {}
        root.location.href = '/cart';
      }
    });
  });
  root.document.addEventListener('cart:updated', function (event) {
    var state = event.detail && event.detail.parsedState;
    if (state && state.items) { cart = state; cartIds = state.items.map(function (line) { return line.product_id; }); config.cartProductIds = cartIds; guardCart(state); }
    else if (cartHasProduct()) refresh(false);
  });
  if (nativeFetch) root.fetch = function (input, options) {
    var url = typeof input === 'string' ? input : input && input.url;
    var result = nativeFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url || '') && (cartHasProduct() || (config.productIds || []).length > 1)) {
      result.then(function (res) { if (res.ok) refresh(true); }, function () {});
    }
    return result;
  };
  // App PDP adds use jQuery/XHR.
  if (root.XMLHttpRequest) {
    var open = root.XMLHttpRequest.prototype.open;
    var send = root.XMLHttpRequest.prototype.send;
    root.XMLHttpRequest.prototype.open = function (method, url) { this.__fbCentrepieceMutation = /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url); return open.apply(this, arguments); };
    root.XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (xhr.__fbCentrepieceMutation) xhr.addEventListener('load', function () { if (xhr.status >= 200 && xhr.status < 300) refresh(true); });
      return send.apply(this, arguments);
    };
  }
  function start() {
    if (cartHasProduct()) refresh(false);
    if (returnToCart && root.openPopupAtStep) root.openPopupAtStep('date');
  }
  if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', start); else start();
})(typeof window !== 'undefined' ? window : globalThis);
